import DebounceInput from '@/components/UI/DebounceInput';
import { hasOwnProperty } from '@/helpers';
import { _notNil } from '@/littledash';
import type { ID } from '@/model/Common.model';
import cn from 'classnames';
import type { FC } from 'react';
import './IndividualSaveRepeater.scss';
import type { Errors } from './IndividualSaveRepeater.utils';

export interface IndividualMetadataTitleProps {
  errors: Errors[];
  title?: string;
  id?: ID;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  hasDuplicate?: boolean;
}

export const IndividualMetadataTitle: FC<IndividualMetadataTitleProps> = ({
  title,
  errors,
  id,
  handleChange,
  disabled,
  hasDuplicate,
}): JSX.Element => {
  const hasErrors = errors.find(({ id: fieldId }) => String(fieldId) === String(id));
  const hasValidationErrors = _notNil(hasErrors) && hasOwnProperty(hasErrors.errors, 'title');
  const hasBlankError =
    hasValidationErrors && hasErrors.errors.title?.some((e: string) => e.includes("can't be blank"));
  const hasActualContent = _notNil(title) && title.trim().length > 0;
  const shouldShowValidationError = hasValidationErrors && (hasBlankError === false || hasActualContent === false);

  return (
    <DebounceInput
      handleChange={handleChange}
      inputProps={{
        name: 'title',
        value: title,
        'data-id': id,
        type: 'text',
        className: cn('z-5 relative input-title-glossary', {
          input__error: shouldShowValidationError === true || hasDuplicate === true,
        }),
        'data-tooltip-id': 'global-tooltip-id',
        'data-tooltip-content':
          hasDuplicate === true
            ? 'Duplicate titles are not allowed'
            : shouldShowValidationError === true
              ? (hasErrors?.errors?.title?.join('; ') ?? '')
              : '',
        disabled,
      }}
    />
  );
};
